export const formatDecimalValue = (value: string) => {
  const onlyNumbers = value.replace(/\D/g, '')
  const addDecimalSeparator = onlyNumbers.replace(/(\d)(\d{2})$/, '$1,$2')
  return addDecimalSeparator
}
